import * as constants from '../constants/constants';
import { axiosCaller } from "../utils/apiCaller";
import {ACTION, wrap, setLoading, setButtonLoading} from './generalActions'
import { toast } from 'react-toastify';
import {GET_WAREHOUSE, GET_WAREHOUSE_INNER_STOCK, GET_WAREHOUSE_LEFT_OVERS, GET_WAREHOUSE_DASHBOARD_STATS, GET_WAREHOUSE_INVENTORY, GET_WAREHOUSE_RECEIVING} from "../constants/constants";
import {apiCaller} from "../utils/apiCaller";
import {translatedText} from "../components/TranslatedText"

export const fetchTransportAssigneesOptions = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `permission-users?module=transport`).then(res => {
            dispatch({ "type": constants.FETCH_TRANSPORT_ASSIGNEES_OPTIONS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const fetchInstallationAssigneesOptions = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `permission-users?module=installation`).then(res => {
            dispatch({ "type": constants.FETCH_INSTALLATION_ASSIGNEES_OPTIONS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const fetchWarehouseClientInformation = (clientId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `warehouse-records/${clientId}/clients`).then(res => {
            dispatch({ "type": constants.FETCH_WAREHOUSE_CLIENT_INFORMATION, "payload": res.data });
            return res.data
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const createWarehouseRecords = (payload) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `warehouse-records`, payload).then(()=>{
            toast.success('Rekordet u krijuan me sukses')
            return
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi keq!"}))
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const editWarehouseRecords = (payload, warehouseRecordId) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `warehouse-records/${warehouseRecordId}`, payload).then(()=>{
            toast.success(translatedText({id:"warehouseEdited",defaultMessage:"Te dhenat u edituan me sukses!"}))
            return
        })
    } catch(err) {
        toast.error(translatedText({id:"somethingWentWrongAlt",defaultMessage:"Diqka shkoi keq!"}))
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const getWarehouseProducts = (payload, clientId, page = 1, perPage = 20, search = '') => wrap(async(dispatch:any) => {
    try {
        let queryParams = `page=${page}&per_page=${perPage}`;
        if (search) {
            queryParams += `&search=${encodeURIComponent(search)}`;
        }
        return await axiosCaller('GET', `warehouse/show?${queryParams}`, payload).then(res => {
            dispatch({ "type": constants.GET_WAREHOUSE_PRODUCTS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const getWarehouseRecordExtraInformation = (projectId) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `warehouse-records/${projectId}/project`).then(res => {
            dispatch({ "type": constants.GET_WAREHOUSE_INFORMATION, "payload": res.data.data });
            return
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

// export const getWarehouseRecord = (warehouseRecordId) => wrap(async(dispatch:any) => {
//     try {
//         return await axiosCaller('GET', `warehouse-records/${warehouseRecordId}`).then(res => {
//             dispatch({ "type": constants.GET_WAREHOUSE, "payload": res.data.data });
//             return
//         })
//     } catch(err) {
//     }
// }, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const setWarehouseRecord = (payload) => wrap(async(dispatch:any) => {
        dispatch({ "type": constants.GET_WAREHOUSE_RECORD, "payload": payload });
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const deleteWarehouseRecord = (warehouseRecordId) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `warehouse-records/${warehouseRecordId}`).then(res => {
            toast.info(translatedText({id:"warehouseDeleted",defaultMessage:"Deponimi u fshi me sukses!"}))
            return
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const getWarehouseLeftOvers = (payload) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `warehouse-records/quantity`, payload).then(res => {
            dispatch({ "type": constants.GET_WAREHOUSE_LEFT_OVERS, "payload": res.data });
            return
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const getInnerStockProducts = (page: number = 1, perPage: number = 20, search: string = '') => wrap(async(dispatch:any) => {
    try {
        let queryParams = `page=${page}&per_page=${perPage}`;
        if (search) {
            queryParams += `&search=${encodeURIComponent(search)}`;
        }
        return await axiosCaller('GET', `warehouse-records/inner/stock?${queryParams}`).then(res => {
            dispatch({ "type": constants.GET_WAREHOUSE_INNER_STOCK, "payload": res?.data });
            return
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const getWarehouseClients = (startDate?, endDate?, withoutTransportFilter?, withoutInstallationFilter?, page = 1, perPage = 20, search = '') => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));

        let queryParams: string[] = [];
        if (startDate && endDate) {
            queryParams.push(`start=${startDate}`);
            queryParams.push(`end=${endDate}`);
        }
        if (withoutTransportFilter) {
            queryParams.push('withoutTransportFilter=1');
        }
        if (withoutInstallationFilter) {
            queryParams.push('withoutInstallationFilter=1');
        }
        queryParams.push(`page=${page}`);
        queryParams.push(`per_page=${perPage}`);
        if (search) {
            queryParams.push(`search=${encodeURIComponent(search)}`);
        }
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

        return await axiosCaller('GET', `warehouse-records-clients${queryString}`).then(res => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.GET_WAREHOUSE_CLIENTS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

export const getWarehouseAllClients = (startDate?, endDate?, withoutTransportFilter?, withoutInstallationFilter?, page = 1, perPage = 20, search = '') => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));

        let queryParams: string[] = [];
        if (startDate && endDate) {
            queryParams.push(`start=${startDate}`);
            queryParams.push(`end=${endDate}`);
        }
        if (withoutTransportFilter) {
            queryParams.push('withoutTransportFilter=1');
        }
        if (withoutInstallationFilter) {
            queryParams.push('withoutInstallationFilter=1');
        }
        queryParams.push(`page=${page}`);
        queryParams.push(`per_page=${perPage}`);
        if (search) {
            queryParams.push(`search=${encodeURIComponent(search)}`);
        }
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

        return await axiosCaller('GET', `warehouse-records-view-all${queryString}`).then(res => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.GET_WAREHOUSE_CLIENTS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_TRANSPORT_ASSIGNEES_OPTIONS')

// ── New warehouse actions ──

export const getWarehouseDashboardStats = () => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('GET', 'warehouse/dashboard-stats').then((res: any) => {
            return res;
        });
    } catch (err) {}
}, 'GET_WAREHOUSE_DASHBOARD_STATS_ERROR')

export const getWarehouseInventory = (page = 1, perPage = 20, search = '', status = '', start = '', end = '', departmentId = '', overdueOnly = false) => wrap(async (dispatch: any) => {
    try {
        let qp: string[] = [`page=${page}`, `per_page=${perPage}`];
        if (search) qp.push(`search=${encodeURIComponent(search)}`);
        if (status) qp.push(`status=${status}`);
        if (start && end) { qp.push(`start=${start}`); qp.push(`end=${end}`); }
        if (departmentId) qp.push(`department_id=${departmentId}`);
        if (overdueOnly) qp.push('overdue_only=1');
        return await apiCaller('GET', `warehouse/inventory?${qp.join('&')}`).then((res: any) => {
            dispatch({ type: GET_WAREHOUSE_INVENTORY, payload: res });
            return res;
        });
    } catch (err) {}
}, 'GET_WAREHOUSE_INVENTORY_ERROR')

export const getWarehouseReceivingList = (page = 1, perPage = 20, search = '', start = '', end = '', departmentId = '') => wrap(async (dispatch: any) => {
    try {
        let qp: string[] = [`page=${page}`, `per_page=${perPage}`];
        if (search) qp.push(`search=${encodeURIComponent(search)}`);
        if (start && end) { qp.push(`start=${start}`); qp.push(`end=${end}`); }
        if (departmentId) qp.push(`department_id=${departmentId}`);
        return await apiCaller('GET', `warehouse/receiving?${qp.join('&')}`).then((res: any) => {
            dispatch({ type: GET_WAREHOUSE_RECEIVING, payload: res });
            return res;
        });
    } catch (err) {}
}, 'GET_WAREHOUSE_RECEIVING_ERROR')

export const receiveProduct = (productId: number, quantity?: number, note?: string, location?: string) => wrap(async (dispatch: any) => {
    try {
        const body: any = {};
        if (quantity !== undefined) body.quantity = quantity;
        if (note) body.note = note;
        if (location) body.location = location;
        return await apiCaller('POST', `warehouse/receiving/${productId}/receive`, body).then((res: any) => {
            return res;
        });
    } catch (err) {
        toast.error(translatedText({id: "somethingWentWrong", defaultMessage: "Diqka nuk shkoi mire"}));
    }
}, 'RECEIVE_PRODUCT_ERROR')

export const batchReceiveProducts = (products: {id: number, quantity: number}[]) => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('POST', 'warehouse/receiving/batch-receive', { products }).then((res: any) => {
            return res;
        });
    } catch (err) {
        toast.error(translatedText({id: "somethingWentWrong", defaultMessage: "Diqka nuk shkoi mire"}));
    }
}, 'BATCH_RECEIVE_ERROR')

export const rejectProduct = (productId: number, category: string, reason: string, quantity?: number) => wrap(async (dispatch: any) => {
    try {
        const body: any = { category, reason };
        if (quantity !== undefined) body.quantity = quantity;
        return await apiCaller('POST', `warehouse/receiving/${productId}/reject`, body).then((res: any) => {
            return res;
        });
    } catch (err) {
        toast.error(translatedText({id: "somethingWentWrong", defaultMessage: "Diqka nuk shkoi mire"}));
    }
}, 'REJECT_PRODUCT_ERROR')

// ── Warehouse Record Comments ──

export const getWarehouseRecordComments = (warehouseRecordId: number) => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('GET', `warehouse-records/${warehouseRecordId}/comments`).then((res: any) => {
            return res;
        });
    } catch (err) {}
}, 'GET_WAREHOUSE_COMMENTS_ERROR')

export const addWarehouseRecordComment = (warehouseRecordId: number, comment: string) => wrap(async (dispatch: any) => {
    try {
        return await axiosCaller('POST', `warehouse-records/${warehouseRecordId}/comments`, { comment }).then((res: any) => {
            return res;
        });
    } catch (err) {
        toast.error(translatedText({id: "commentNotSaved", defaultMessage: "Komenti nuk u ruajt"}));
    }
}, 'ADD_WAREHOUSE_COMMENT_ERROR')

export const deleteWarehouseRecordComment = (commentId: number) => wrap(async (dispatch: any) => {
    try {
        return await apiCaller('DELETE', `warehouse-records/comments/${commentId}`).then((res: any) => {
            return res;
        });
    } catch (err) {
        toast.error(translatedText({id: "commentNotDeleted", defaultMessage: "Komenti nuk u fshi"}));
    }
}, 'DELETE_WAREHOUSE_COMMENT_ERROR')